// Global country + dial-code list. Alphabetically sorted so the signup
// <select> is browsable at a glance. Feb 2026 — expanded from the earlier
// hand-picked shortlist so no country is hardcoded as "not available";
// country availability is now driven by the satisFINDER country
// availability configuration (waitlist / blocked / open).
//
// Every entry maps: { name, dial } — used for the country selector on
// the satisFINDER signup form. `dial` is auto-populated into the mobile
// country-code field whenever the country changes.
export const COUNTRIES = [
  { name: 'Afghanistan', dial: '+93', iso: 'AF' },
  { name: 'Albania', dial: '+355', iso: 'AL' },
  { name: 'Algeria', dial: '+213', iso: 'DZ' },
  { name: 'Andorra', dial: '+376', iso: 'AD' },
  { name: 'Angola', dial: '+244', iso: 'AO' },
  { name: 'Antigua and Barbuda', dial: '+1', iso: 'AG' },
  { name: 'Argentina', dial: '+54', iso: 'AR' },
  { name: 'Armenia', dial: '+374', iso: 'AM' },
  { name: 'Australia', dial: '+61', iso: 'AU' },
  { name: 'Austria', dial: '+43', iso: 'AT' },
  { name: 'Azerbaijan', dial: '+994', iso: 'AZ' },
  { name: 'Bahamas', dial: '+1', iso: 'BS' },
  { name: 'Bahrain', dial: '+973', iso: 'BH' },
  { name: 'Bangladesh', dial: '+880', iso: 'BD' },
  { name: 'Barbados', dial: '+1', iso: 'BB' },
  { name: 'Belarus', dial: '+375', iso: 'BY' },
  { name: 'Belgium', dial: '+32', iso: 'BE' },
  { name: 'Belize', dial: '+501', iso: 'BZ' },
  { name: 'Benin', dial: '+229', iso: 'BJ' },
  { name: 'Bhutan', dial: '+975', iso: 'BT' },
  { name: 'Bolivia', dial: '+591', iso: 'BO' },
  { name: 'Bosnia and Herzegovina', dial: '+387', iso: 'BA' },
  { name: 'Botswana', dial: '+267', iso: 'BW' },
  { name: 'Brazil', dial: '+55', iso: 'BR' },
  { name: 'Brunei', dial: '+673', iso: 'BN' },
  { name: 'Bulgaria', dial: '+359', iso: 'BG' },
  { name: 'Burkina Faso', dial: '+226', iso: 'BF' },
  { name: 'Burundi', dial: '+257', iso: 'BI' },
  { name: 'Cambodia', dial: '+855', iso: 'KH' },
  { name: 'Cameroon', dial: '+237', iso: 'CM' },
  { name: 'Canada', dial: '+1', iso: 'CA' },
  { name: 'Cape Verde', dial: '+238', iso: 'CV' },
  { name: 'Central African Republic', dial: '+236', iso: 'CF' },
  { name: 'Chad', dial: '+235', iso: 'TD' },
  { name: 'Chile', dial: '+56', iso: 'CL' },
  { name: 'China', dial: '+86', iso: 'CN' },
  { name: 'Colombia', dial: '+57', iso: 'CO' },
  { name: 'Comoros', dial: '+269', iso: 'KM' },
  { name: 'Congo (Brazzaville)', dial: '+242', iso: 'CG' },
  { name: 'Congo (Kinshasa)', dial: '+243', iso: 'CD' },
  { name: 'Costa Rica', dial: '+506', iso: 'CR' },
  { name: "Côte d'Ivoire", dial: '+225' },
  { name: 'Croatia', dial: '+385', iso: 'HR' },
  { name: 'Cuba', dial: '+53', iso: 'CU' },
  { name: 'Cyprus', dial: '+357', iso: 'CY' },
  { name: 'Czech Republic', dial: '+420', iso: 'CZ' },
  { name: 'Denmark', dial: '+45', iso: 'DK' },
  { name: 'Djibouti', dial: '+253', iso: 'DJ' },
  { name: 'Dominica', dial: '+1', iso: 'DM' },
  { name: 'Dominican Republic', dial: '+1', iso: 'DO' },
  { name: 'Ecuador', dial: '+593', iso: 'EC' },
  { name: 'Egypt', dial: '+20', iso: 'EG' },
  { name: 'El Salvador', dial: '+503', iso: 'SV' },
  { name: 'Equatorial Guinea', dial: '+240', iso: 'GQ' },
  { name: 'Eritrea', dial: '+291', iso: 'ER' },
  { name: 'Estonia', dial: '+372', iso: 'EE' },
  { name: 'Eswatini', dial: '+268', iso: 'SZ' },
  { name: 'Ethiopia', dial: '+251', iso: 'ET' },
  { name: 'Fiji', dial: '+679', iso: 'FJ' },
  { name: 'Finland', dial: '+358', iso: 'FI' },
  { name: 'France', dial: '+33', iso: 'FR' },
  { name: 'Gabon', dial: '+241', iso: 'GA' },
  { name: 'Gambia', dial: '+220', iso: 'GM' },
  { name: 'Georgia', dial: '+995', iso: 'GE' },
  { name: 'Germany', dial: '+49', iso: 'DE' },
  { name: 'Ghana', dial: '+233', iso: 'GH' },
  { name: 'Greece', dial: '+30', iso: 'GR' },
  { name: 'Grenada', dial: '+1', iso: 'GD' },
  { name: 'Guatemala', dial: '+502', iso: 'GT' },
  { name: 'Guinea', dial: '+224', iso: 'GN' },
  { name: 'Guinea-Bissau', dial: '+245', iso: 'GW' },
  { name: 'Guyana', dial: '+592', iso: 'GY' },
  { name: 'Haiti', dial: '+509', iso: 'HT' },
  { name: 'Honduras', dial: '+504', iso: 'HN' },
  { name: 'Hong Kong', dial: '+852', iso: 'HK' },
  { name: 'Hungary', dial: '+36', iso: 'HU' },
  { name: 'Iceland', dial: '+354', iso: 'IS' },
  { name: 'India', dial: '+91', iso: 'IN' },
  { name: 'Indonesia', dial: '+62', iso: 'ID' },
  { name: 'Iran', dial: '+98', iso: 'IR' },
  { name: 'Iraq', dial: '+964', iso: 'IQ' },
  { name: 'Ireland', dial: '+353', iso: 'IE' },
  { name: 'Israel', dial: '+972', iso: 'IL' },
  { name: 'Italy', dial: '+39', iso: 'IT' },
  { name: 'Jamaica', dial: '+1', iso: 'JM' },
  { name: 'Japan', dial: '+81', iso: 'JP' },
  { name: 'Jordan', dial: '+962', iso: 'JO' },
  { name: 'Kazakhstan', dial: '+7', iso: 'KZ' },
  { name: 'Kenya', dial: '+254', iso: 'KE' },
  { name: 'Kiribati', dial: '+686', iso: 'KI' },
  { name: 'Kuwait', dial: '+965', iso: 'KW' },
  { name: 'Kyrgyzstan', dial: '+996', iso: 'KG' },
  { name: 'Laos', dial: '+856', iso: 'LA' },
  { name: 'Latvia', dial: '+371', iso: 'LV' },
  { name: 'Lebanon', dial: '+961', iso: 'LB' },
  { name: 'Lesotho', dial: '+266', iso: 'LS' },
  { name: 'Liberia', dial: '+231', iso: 'LR' },
  { name: 'Libya', dial: '+218', iso: 'LY' },
  { name: 'Liechtenstein', dial: '+423', iso: 'LI' },
  { name: 'Lithuania', dial: '+370', iso: 'LT' },
  { name: 'Luxembourg', dial: '+352', iso: 'LU' },
  { name: 'Macau', dial: '+853', iso: 'MO' },
  { name: 'Madagascar', dial: '+261', iso: 'MG' },
  { name: 'Malawi', dial: '+265', iso: 'MW' },
  { name: 'Malaysia', dial: '+60', iso: 'MY' },
  { name: 'Maldives', dial: '+960', iso: 'MV' },
  { name: 'Mali', dial: '+223', iso: 'ML' },
  { name: 'Malta', dial: '+356', iso: 'MT' },
  { name: 'Marshall Islands', dial: '+692', iso: 'MH' },
  { name: 'Mauritania', dial: '+222', iso: 'MR' },
  { name: 'Mauritius', dial: '+230', iso: 'MU' },
  { name: 'Mexico', dial: '+52', iso: 'MX' },
  { name: 'Micronesia', dial: '+691', iso: 'FM' },
  { name: 'Moldova', dial: '+373', iso: 'MD' },
  { name: 'Monaco', dial: '+377', iso: 'MC' },
  { name: 'Mongolia', dial: '+976', iso: 'MN' },
  { name: 'Montenegro', dial: '+382', iso: 'ME' },
  { name: 'Morocco', dial: '+212', iso: 'MA' },
  { name: 'Mozambique', dial: '+258', iso: 'MZ' },
  { name: 'Myanmar', dial: '+95', iso: 'MM' },
  { name: 'Namibia', dial: '+264', iso: 'NA' },
  { name: 'Nauru', dial: '+674', iso: 'NR' },
  { name: 'Nepal', dial: '+977', iso: 'NP' },
  { name: 'Netherlands', dial: '+31', iso: 'NL' },
  { name: 'New Zealand', dial: '+64', iso: 'NZ' },
  { name: 'Nicaragua', dial: '+505', iso: 'NI' },
  { name: 'Niger', dial: '+227', iso: 'NE' },
  { name: 'Nigeria', dial: '+234', iso: 'NG' },
  { name: 'North Korea', dial: '+850', iso: 'KP' },
  { name: 'North Macedonia', dial: '+389', iso: 'MK' },
  { name: 'Norway', dial: '+47', iso: 'NO' },
  { name: 'Oman', dial: '+968', iso: 'OM' },
  { name: 'Pakistan', dial: '+92', iso: 'PK' },
  { name: 'Palau', dial: '+680', iso: 'PW' },
  { name: 'Palestine', dial: '+970', iso: 'PS' },
  { name: 'Panama', dial: '+507', iso: 'PA' },
  { name: 'Papua New Guinea', dial: '+675', iso: 'PG' },
  { name: 'Paraguay', dial: '+595', iso: 'PY' },
  { name: 'Peru', dial: '+51', iso: 'PE' },
  { name: 'Philippines', dial: '+63', iso: 'PH' },
  { name: 'Poland', dial: '+48', iso: 'PL' },
  { name: 'Portugal', dial: '+351', iso: 'PT' },
  { name: 'Qatar', dial: '+974', iso: 'QA' },
  { name: 'Romania', dial: '+40', iso: 'RO' },
  { name: 'Russia', dial: '+7', iso: 'RU' },
  { name: 'Rwanda', dial: '+250', iso: 'RW' },
  { name: 'Saint Kitts and Nevis', dial: '+1', iso: 'KN' },
  { name: 'Saint Lucia', dial: '+1', iso: 'LC' },
  { name: 'Saint Vincent and the Grenadines', dial: '+1', iso: 'VC' },
  { name: 'Samoa', dial: '+685', iso: 'WS' },
  { name: 'San Marino', dial: '+378', iso: 'SM' },
  { name: 'São Tomé and Príncipe', dial: '+239', iso: 'ST' },
  { name: 'Saudi Arabia', dial: '+966', iso: 'SA' },
  { name: 'Senegal', dial: '+221', iso: 'SN' },
  { name: 'Serbia', dial: '+381', iso: 'RS' },
  { name: 'Seychelles', dial: '+248', iso: 'SC' },
  { name: 'Sierra Leone', dial: '+232', iso: 'SL' },
  { name: 'Singapore', dial: '+65', iso: 'SG' },
  { name: 'Slovakia', dial: '+421', iso: 'SK' },
  { name: 'Slovenia', dial: '+386', iso: 'SI' },
  { name: 'Solomon Islands', dial: '+677', iso: 'SB' },
  { name: 'Somalia', dial: '+252', iso: 'SO' },
  { name: 'South Africa', dial: '+27', iso: 'ZA' },
  { name: 'South Korea', dial: '+82', iso: 'KR' },
  { name: 'South Sudan', dial: '+211', iso: 'SS' },
  { name: 'Spain', dial: '+34', iso: 'ES' },
  { name: 'Sri Lanka', dial: '+94', iso: 'LK' },
  { name: 'Sudan', dial: '+249', iso: 'SD' },
  { name: 'Suriname', dial: '+597', iso: 'SR' },
  { name: 'Sweden', dial: '+46', iso: 'SE' },
  { name: 'Switzerland', dial: '+41', iso: 'CH' },
  { name: 'Syria', dial: '+963', iso: 'SY' },
  { name: 'Taiwan', dial: '+886', iso: 'TW' },
  { name: 'Tajikistan', dial: '+992', iso: 'TJ' },
  { name: 'Tanzania', dial: '+255', iso: 'TZ' },
  { name: 'Thailand', dial: '+66', iso: 'TH' },
  { name: 'Timor-Leste', dial: '+670', iso: 'TL' },
  { name: 'Togo', dial: '+228', iso: 'TG' },
  { name: 'Tonga', dial: '+676', iso: 'TO' },
  { name: 'Trinidad and Tobago', dial: '+1', iso: 'TT' },
  { name: 'Tunisia', dial: '+216', iso: 'TN' },
  { name: 'Turkey', dial: '+90', iso: 'TR' },
  { name: 'Turkmenistan', dial: '+993', iso: 'TM' },
  { name: 'Tuvalu', dial: '+688', iso: 'TV' },
  { name: 'Uganda', dial: '+256', iso: 'UG' },
  { name: 'Ukraine', dial: '+380', iso: 'UA' },
  { name: 'United Arab Emirates', dial: '+971', iso: 'AE' },
  { name: 'United Kingdom', dial: '+44', iso: 'GB' },
  { name: 'United States', dial: '+1', iso: 'US' },
  { name: 'Uruguay', dial: '+598', iso: 'UY' },
  { name: 'Uzbekistan', dial: '+998', iso: 'UZ' },
  { name: 'Vanuatu', dial: '+678', iso: 'VU' },
  { name: 'Vatican City', dial: '+39', iso: 'VA' },
  { name: 'Venezuela', dial: '+58', iso: 'VE' },
  { name: 'Vietnam', dial: '+84', iso: 'VN' },
  { name: 'Yemen', dial: '+967', iso: 'YE' },
  { name: 'Zambia', dial: '+260', iso: 'ZM' },
  { name: 'Zimbabwe', dial: '+263', iso: 'ZW' },
];

// Convert an ISO alpha-2 code (e.g. 'ES') into its regional-indicator flag
// emoji (🇪🇸). Falls back to an empty string for invalid inputs so the UI
// never renders a stray placeholder character.
export function iso2ToFlag(iso2) {
  if (!iso2 || typeof iso2 !== 'string' || iso2.length !== 2) return '';
  try {
    const cp = [...iso2.toUpperCase()].map(c => 0x1F1E6 + c.charCodeAt(0) - 65);
    return String.fromCodePoint(...cp);
  } catch { return ''; }
}

// Reasonable mobile length band per ISO alpha-2 country. Applied against
// the digits-only mobile number. Missing entries fall back to a permissive
// 6..15 range (ITU-T E.164 subscriber max).
export const MOBILE_LENGTH_BY_ISO = {
  US: [10, 10], CA: [10, 10], GB: [10, 10], AU: [9, 9],
  DE: [10, 11], FR: [9, 9], ES: [9, 9], IT: [9, 10],
  NL: [9, 9], BE: [9, 9], SE: [9, 9], NO: [8, 8], DK: [8, 8], FI: [9, 10],
  IE: [9, 9], PT: [9, 9], AT: [10, 11], CH: [9, 9], PL: [9, 9], CZ: [9, 9],
  RU: [10, 10], UA: [9, 9], TR: [10, 10], GR: [10, 10],
  IN: [10, 10], PK: [10, 10], BD: [10, 10], NP: [10, 10], LK: [9, 9],
  PH: [10, 10], ID: [9, 12], MY: [9, 10], SG: [8, 8], TH: [9, 9], VN: [9, 10],
  JP: [10, 11], KR: [9, 11], HK: [8, 8], TW: [9, 9], MO: [8, 8], CN: [11, 11],
  MX: [10, 10], BR: [10, 11], AR: [10, 10], CL: [9, 9], CO: [10, 10], PE: [9, 9],
  ZA: [9, 9], EG: [10, 10], NG: [10, 10], KE: [9, 10], MA: [9, 9], AE: [9, 9],
  SA: [9, 9], QA: [8, 8], KW: [8, 8], BH: [8, 8], OM: [8, 8], IL: [9, 9], JO: [9, 9],
  NZ: [8, 10],
};

// Retained for backwards compatibility with any surface that still imports
// these (Feb 2026 signup no longer collects age/gender at registration).
export const AGE_GROUPS = ['18 to 24', '25 to 34', '35 to 44', '45 to 54', '55 to 64', '65+'];
export const GENDERS = ['Female', 'Male', 'Non-binary', 'Prefer not to say'];
